export const NONE = 0
export const NOT_STARTED = 1
export const IN_PROGRESS = 2
export const COMPLETED = 3
